import { BaseModel } from "../../../shared/base/base.models";
import { UserType } from "../users/users.models";
import { BusinessPartner } from "../business-partners/business-partners.models";
import { SearchOperations } from "src/app/app.constants";

export class RegistrationsRequests extends BaseModel {
    businessPartner: BusinessPartner;
    companyId: string;
    email: string;
    id: string;
    idNumber: string;
    name: string;
    note: string;
    relatedEntity: string;
    status: RegistrationsRequestsStatus;
    suggestionName: string;
    telephone: string;
    userId: string;
    userType: UserType;
}

export enum RegistrationsRequestsStatus {
    NEW = 'NEW', APPROVED = 'APPROVED', DECLINED = 'DECLINED'
}

// export class RegistrationTab {
//     public titleKey: string;
//     public searchParam: string;
// }

export class RegistrationKey {
    public static readonly NEW = 'NEW';
    public static readonly APPROVED =  'APPROVED';
    public static readonly DECLINED = 'DECLINED';
}